import { render } from "./BaseUI.vue?vue&type=template&id=68d696e5&scoped=true"
import script from "./BaseUI.vue?vue&type=script&lang=js"
export * from "./BaseUI.vue?vue&type=script&lang=js"

import "./BaseUI.vue?vue&type=style&index=0&id=68d696e5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d696e5"]])

export default __exports__